import { FilterDefinition } from '../StagingFilterBuilder';
import { EquipmentTypeFilter, RangeFilter } from '../../../../redux/constants/filters';
import EquipmentTypeFilterPopover from './EquipmentTypeFilterPopover';
import SliderFilterPopover, { SliderOptions } from './SliderFilterPopover';

export const equipTypeFilter = new FilterDefinition(
  EquipmentTypeFilterPopover,
  'equip_type',
  'Equip Type',
  {},
  (type) =>
    new EquipmentTypeFilter({
      key: 'equip_type',
      getter: (e) => e.equipment_type_id,
      type,
    })
);

export function buildConfidenceFilter({ getConfidence }) {
  return new FilterDefinition(
    SliderFilterPopover,
    'confidence',
    'Confidence',
    new SliderOptions([0, 100], [50, 100]),
    (v) =>
      new RangeFilter({
        key: 'confidence',
        getter: getConfidence,
        minimum: v[0],
        maximum: v[1],
      })
  );
}
